module.exports = "7a2cede8060f6986431af7e21bac66b4.ogg";


//////////////////
// WEBPACK FOOTER
// ./assets/music/track4_merged.ogg
// module id = 34
// module chunks = 0